import type { ReactElement } from 'react';
import React from 'react';

import { Box, Heading } from '@zillow/constellation';

interface HeroHeadlineProps {
    headerText: string;
    subHeaderText?: string;
}
const HeroHeadline: React.FC<HeroHeadlineProps> = ({
    headerText,
    subHeaderText,
}: HeroHeadlineProps): ReactElement => (
    <Box
        sx={{
            filter: 'drop-shadow(0px 0px 5px #000)',
            width: '100%',
            textAlign: 'center',
        }}
    >
        <Heading
            level={1}
            fontFamily="serif"
            fontType={{ xs: 'h4', lg: 'h3' }}
            fontColor="textWhite"
            marginBottom={{ xs: 'sm', lg: 'lg' }}
        >
            {headerText}
        </Heading>
        {subHeaderText && (
            <Heading level={2} margin="lg" marginBottom="md" fontType="h5" fontColor="textWhite">
                {subHeaderText}
            </Heading>
        )}
    </Box>
);

HeroHeadline.defaultProps = {
    subHeaderText: undefined,
};

export default HeroHeadline;
